module.exports = __webpack_public_path__ + "media/animation.209fdc9c.mp4";